import { render, staticRenderFns } from "./assignables.vue?vue&type=template&id=60f57bb2&"
import script from "./assignables.vue?vue&type=script&lang=js&"
export * from "./assignables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports